import styled, { css } from 'styled-components';
import { spacer4, spacer12, spacer16, spacer20, spacer48 } from '@spotify-internal/encore-foundation';
import { transitionFade, typeStyleBody2 } from "../../styles";
export default styled.div.attrs({
  role: 'alert',
  'aria-live': 'assertive'
}).withConfig({
  displayName: "Wrapper",
  componentId: "lksjfp-0"
})(["", ";align-items:flex-start;background-color:", ";color:", ";display:flex;justify-content:", ";padding:", ";position:relative;transition:background ", ";", ";+ &{margin-top:", ";}a{border:1px solid transparent;color:currentColor !important;&:focus{border-color:currentColor;border-style:dotted;}}"], typeStyleBody2(), function (props) {
  return props.theme.banner.backgroundColor;
}, function (props) {
  return props.theme.banner.color;
}, function (props) {
  return props.theme.banner.align === 'center' ? 'center' : 'space-between';
}, function (props) {
  return props.showClose ? "".concat(spacer12, " ").concat(spacer48, " ").concat(spacer12, " ").concat(spacer16) : "".concat(spacer12, " ").concat(spacer16);
}, transitionFade, function (props) {
  return props.theme.banner.contextual && css(["border-radius:", ";"], spacer4);
}, spacer20);